import { Grid, ScreenShare } from './icons';

/**
 * Lista lateral de quem esta transmitindo.
 *
 * Escolher aqui nao e so filtrar o que aparece na tela: as transmissoes nao
 * escolhidas sao **canceladas na origem** (ver `Room.tsx`), entao o navegador
 * para de baixa-las. Com tres pessoas transmitindo em 1080p, assistir a uma so
 * e a diferenca entre 8 e 24 Mb/s de download.
 *
 * Quem nao esta sendo assistido continua no ar normalmente para os outros —
 * a escolha vale so para voce.
 */

export interface Transmissor {
  identity: string;
  nome: string;
  avatar: string | null;
  isLocal: boolean;
}

export function ListaDeTelas({
  transmissores,
  selecionado,
  onSelecionar,
}: {
  transmissores: Transmissor[];
  selecionado: string | null;
  onSelecionar: (identity: string | null) => void;
}) {
  // Com um transmissor so, escolher nao faz sentido — a lista so ocuparia espaco.
  if (transmissores.length < 2) return null;

  return (
    <aside className="lista-telas" aria-label="Quem esta transmitindo">
      <button
        className="item-tela"
        data-ativo={selecionado === null || undefined}
        onClick={() => onSelecionar(null)}
      >
        <span className="item-icone">
          <Grid size={16} />
        </span>
        <span className="item-nome">Todas</span>
        <span className="item-contagem">{transmissores.length}</span>
      </button>

      {transmissores.map((t) => (
        <button
          key={t.identity}
          className="item-tela"
          data-ativo={selecionado === t.identity || undefined}
          onClick={() => onSelecionar(t.identity)}
          title={t.nome}
        >
          <span className="item-icone">
            {t.avatar ? (
              <img src={t.avatar} alt="" />
            ) : (
              <ScreenShare size={16} />
            )}
          </span>
          <span className="item-nome">
            {t.nome}
            {t.isLocal && ' (voce)'}
          </span>
          <span className="ao-vivo" aria-label="ao vivo" />
        </button>
      ))}
    </aside>
  );
}
